#import "../../../../../scheduler/graphql/fragments/meeting-validity-issue-fragment.graphql"

fragment MeetingForLandingPage on Meeting {
    id
    name
    meetingType
    isActive
    deletedTime
    htmlUrlPath
    validity {
        issues {
            ...MeetingValidityIssueFragment
        }
        isBookable
    }
    creator {
        id
        name
        firstName
    }
    cohosts {
        id
        name
    }
    activityType {
        id
        name
    }
    durationMinutes
    bookings {
        id
    }
}
